// @flow
import type { Epic } from '../../../annotations';

import { search } from '../../signals';
import { FILTERING } from '../../../domain/messages';
import { select } from 'redux-most';
import * as r from 'ramda';
import * as mostc from '../../../crosscutting/mostc';
import { getDst } from '../../../domain/selectors';

const filterSearchEpic = (): Epic => (
  actions$,
  store,
) => r.pipe(
  select(FILTERING),
  mostc.map(() => {
    const state = store.getState();

    const {
      query,
      filters,
    } = getDst(state);

    return search(
      query,
      filters,
      'filters',
    );
  }),
)(actions$);

export default filterSearchEpic;
